const formMixin = {
}

export default formMixin



// WEBPACK FOOTER //
// ./src/views/baseForm/mixins/formMixin.js